import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleReportAdminUsersComponent } from './schedule-report-admin-users.component';
import {
    ConfirmModule,
    LayoutModule,
    FormBuilderCheckboxModule,
    TableModule,
    TableSearchModule,
} from '@monsido/angular-shared-components';
import { FormsModule } from '@angular/forms';
import { IconsModule } from '@layout/icons/icons.module';
import { GetUserNameModule } from '@monsido/ng2/shared/pipes/get-user-name/get-user-name.module';

import { TranslateModule } from '@client/app/modules/translate.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MonAvatarComponent } from '@client/app/shared/mon-avatar/mon-avatar.component';

@NgModule({
    declarations: [ScheduleReportAdminUsersComponent],
    imports: [
        CommonModule,
        LayoutModule,
        TranslateModule,
        ConfirmModule,
        FormsModule,
        IconsModule,
        FormBuilderCheckboxModule,
        GetUserNameModule,
        TableModule,
        TableSearchModule,
        NgbModule,
        MonAvatarComponent,
    ],
    exports: [ScheduleReportAdminUsersComponent],
})
export class ScheduleReportAdminUsersModule {}
